import * as React from 'react';
import { memo } from 'react';
import { ApolloProvider } from '@apollo/react-hooks';

import { useGraphQLClient } from '../../graphql-client';
import SocialAuth, { Props } from './SocialAuth';

const Component: React.FunctionComponent<Props> = memo(props => {
	const client = useGraphQLClient();

	return (
		<ApolloProvider client={client}>
			<SocialAuth {...props} />
		</ApolloProvider>
	);
});

Component.displayName = 'SocialAuth';

export default Component;
